import Vue from 'vue';
import Router from 'vue-router';
import store from "./store";
import axios from 'axios';
import cookies from 'js-cookie';
import tool from './utils/tool';
Vue.use(Router);



var $router = new Router({
  mode:'hash',  //使用history防止url中出现#
  routes: [
	{
	  path: '/show/:id',
	  component: function (){
	  		 return import ('@/pages/show')
	  },
	  meta : {
		  keepAlive : false
	  },
	  beforeEnter: (to, from, next) => {
			//console.log('page1 beforeEnter~');
			next();
	  }

	},
    {
      path: '/home',
      component: function (){
      		 return import ('@/pages/home')
      },
      meta : {
      		  keepAlive : false
      },
      beforeEnter: (to, from, next) => {
      			//console.log('home beforeEnter~');
      			next();
      }
    },
	{
	  path: '/detail/:id',
	  component: function (){
	  		 return import ('@/pages/detail')
	  },
	  meta : {
	  		  keepAlive : false
	  },
	  beforeEnter: (to, from, next) => {
	  			//console.log('page3 beforeEnter~');
	  			next();
	  }
	},
	 {
		 path: '/deletecookie', component :  function (){
	  		 return 'deletecookie';
		}
	 },
	 {
	 		 path: '/deletestorage', component :  function (){
	 			 var storage=window.localStorage;
	 			 storage.setItem('likedMap',JSON.stringify({}));
	  		 return 'deletestorage';
	 		}
	 },
     { path: '*', redirect: '/home' }


  ]
})


$router. beforeEach((to,from,next) => {
	//console.log('beforeEach~~~~~');

	if(tool.getUrlKey('from') == 'xcx' && cookies.get('fromXCX') != 'true'){
		cookies.set('fromXCX', true);
	}else if(tool.getUrlKey('from') != 'xcx' && cookies.get('fromXCX') == 'true'){
		cookies.set('fromXCX', null);
	}

	if(cookies.get('fromXCX') == 'true' && !store.state.miniapp){
		store.commit('setState', {miniapp: true});
	}

	if(!store.state.authed && cookies.get('sys_newuserinfo')){
		store.commit('setState', {authed: true});
		axios
		.get('/campaigns-b/try/index.php?_c=callback&_a=userinfo')
		.then((response) => {
			console.log('userinfo~~~~~')
			let d = response.data.data;
			// console.log(response.data.data)
			store.commit('setState',{
				userInfo : d,
				userInfoId : d.id,
				site_yhxy : d.site_yhxy||''
			})
		}).catch(function (error) { // 请求失败处理
			console.log(error);
		});
	}

	if(store.state.authed){
		console.log('已授权')
	}else{
		console.log('未授权')
	}

	next();
})

$router. beforeResolve((to,from,next) => {
	//console.log('beforeResolve~~~~~');
	next();
})



export default $router;
